export default class ClientProfile {
  constructor(context) {
    this.context = context;
    this.axios = this.context.$axios;
  }

  //CREATE USER
  async createUser(userInfo) {
    try {
      const user = await this.axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/users/create-user`,
        userInfo
      );
      return user;
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }

  // PROFILE INFO
  async getProfile(subscriberId, businessUnitId) {
    try {
      const infoProfile = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/subscribers/${subscriberId}/baseinfo?businessUnitId=${businessUnitId}`
      );

      return {
        ...infoProfile.data
      };
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }
  //GET USER INFO
  async getUserInfo(userEmail, businessUnitId) {
    try {
      const userInfo = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/users/${userEmail}/${businessUnitId}`
      );
      return { ...userInfo.data };
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }
  //UPDATE USER COMPLETE DATA
  async updateUser(userId, userInfo) {
    try {
      const user = await this.axios.patch(
        `${process.env.VUE_APP_API_BASE_URL}/users/${userId}`,
        userInfo
      );
      return user;
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }

  //UPDATE USER EMAIL AND USERNAME
  async updateUserInfo(userId, userInfo) {
    try {
      const userInfoData = await this.axios.patch(
        `${process.env.VUE_APP_API_BASE_URL}/users/update-user/${userId}`,
        userInfo
      );
      return userInfoData;
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }

  //UPDATE USER PASSWORD
  async updateUserPassword(userId, userInfo) {
    try {
      const userPassword = await this.axios.patch(
        `${process.env.VUE_APP_API_BASE_URL}/users/update-user-password/${userId}`,
        userInfo
      );
      return userPassword;
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
      return err.statusCode;
    }
  }

  // UPDATE PROFILE INFO
  async updateProfile(data, subscriberId, businessUnitId) {
    try {
      const update = await this.axios.patch(
        `${process.env.VUE_APP_API_BASE_URL}/subscribers/${subscriberId}?businessUnitId=${businessUnitId}`,
        data
      );
      console.log(
        `Status text:${update.statusText} Status code:${update.status} Data update:${update.data}`
      );
      console.log(update.status);
      return update.status;
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
      return err.toString();
    }
  }
}
